/* -----------------------------
    ADA MODIFICATIONS
   ----------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  function findHeaderWithText(text, doc) {
    const headers = doc.querySelectorAll('h4.rp-messenger-widget-content-header.rp-widget-header.rp-align-items-space-between');

    for (let i = 0; i < headers.length; i++) {
      if (headers[i].textContent === text) {
        return headers[i];
      }
    }

    return null;
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        const iframe = document.getElementById('richpanel_messenger_iframe');
        // richDiv exists only when the messenger is closed and hasnt been opened
        const richDiv = document.querySelector('.richpanel-micro');
        if (iframe) {
          iframe.title = 'Support Chat Messenger';
          const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

          const iframeObserver = new MutationObserver(function (iframeMutations) {
            iframeMutations.forEach(function (iframeMutation) {
              if (iframeMutation.type === "childList") {
                const openedElement = iframeDocument.querySelector('.rp-messenger-container.opened');
                if (openedElement) {
                  const targetElement = findHeaderWithText('Help us with a few details', iframeDocument);
                  if (targetElement) {
                    const newElement = iframeDocument.createElement('p');
                    newElement.className = "rp-messenger-form-item__label rp-flex";
                    newElement.innerText = "Asterisks (*) indicate required fields.";
                    newElement.id = "asterisks-label"
                    if (!iframeDocument.getElementById('asterisks-label')) {
                      targetElement.insertAdjacentElement('afterend', newElement);
                    }
                  }
                }

                const chatPanel = iframeDocument.querySelector('.rp-messenger-conversation-messages');
                if (chatPanel) {
                  iframeDocument.querySelectorAll('.rp-helpdesk-conversation-message-time').forEach((el) => {
                    el.style.opacity = '1';
                  });
                }

                const preloader = iframeDocument.querySelector('#preloader');
                if (preloader) {
                  let images = preloader.getElementsByTagName('img');

                  for (let i = 0; i < images.length; i++) {
                    let imgSrc = images[i].getAttribute('src');

                    // Check if src attribute exists and if it's not empty
                    if (imgSrc == null || imgSrc.trim() === "" || imgSrc == window.location.href) {
                      images[i].parentNode.removeChild(images[i]);
                      i--;
                    }
                  }
                }
              }
            });
          });

          iframeObserver.observe(iframeDocument, {
            childList: true,
            subtree: true,
          });

          observer.disconnect(); // Disconnect the main observer after the iframe observer is set up.
        } else if (richDiv && !richDiv.hasAttribute('aria-label')) {
          // richDiv.setAttribute('aria-label', 'Open Messenger');
          //
          // var svgButtons = document.querySelectorAll('.rp-micro-app-cross-icon');
          // if (svgButtons.length) {
          //   for (var i = 0; i < svgButtons.length; i++) {
          //     svgButtons[i].parentNode.setAttribute('role', 'button');
          //   }
          // }
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
